import React from 'react';
import {
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';

export interface ColumnVisibilityItem {
  key: string;
  label: string;
  visible: boolean;
}

interface ColumnVisibilityMenuProps {
  anchorEl: HTMLElement | null;
  items: ColumnVisibilityItem[];
  onClose: () => void;
  onToggle: (key: string) => void;
  side?: boolean;
}

const ColumnVisibilityMenu: React.FC<ColumnVisibilityMenuProps> = ({
  anchorEl,
  items,
  onClose,
  onToggle,
  side = false,
}) => {
  const { t } = useLanguage();

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={side ? { vertical: 'top', horizontal: 'left' } : undefined}
      transformOrigin={side ? { vertical: 'top', horizontal: 'right' } : undefined}
      PaperProps={{ sx: { minWidth: side ? 240 : 200, ...(side ? { borderRadius: '12px 0 0 12px', border: '1px solid', borderColor: 'divider', boxShadow: '0 12px 28px rgba(32, 55, 44, .18)' } : {}) } }}
    >
      <ListSubheader disableSticky>{t('common.columns')}</ListSubheader>
      {items.map((item) => (
        <MenuItem key={item.key} onClick={() => onToggle(item.key)}>
          <ListItemIcon>
            {item.visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </ListItemIcon>
          <ListItemText>{item.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ColumnVisibilityMenu;
